import { useFirebaseApp } from 'reactfire'

export const useFunctions = () => {
  const functions = useFirebaseApp().functions('asia-east2')
  // functions.useFunctionsEmulator('http://localhost:5001')
  return functions
}
